export const LOAD_OUR_SERVICES = "LOAD_OUR_SERVICES";
export const GET_SERVICE_BY_ID = "GET_SERVICE_BY_ID";
export const LOAD_APPLICATION_SERVICES = "LOAD_APPLICATION_SERVICES";
